import { Controller } from "@hotwired/stimulus"

// Reveals the avatar picker only while the "avatar" toggle element is selected,
// and drives the custom-upload slot inside it.
export default class extends Controller {
  static targets = ["select", "avatarFields", "customRadio", "customPreview", "customFile"]

  connect() {
    this.updateFields()
  }

  updateFields() {
    if (!this.hasSelectTarget || !this.hasAvatarFieldsTarget) {
      return
    }

    this.avatarFieldsTarget.classList.toggle("hidden", this.selectTarget.value !== "avatar")
  }

  // Shows the file the owner just picked, before it is uploaded, and selects the
  // custom slot — picking a file means intending to use it.
  //
  // A data: URL, not URL.createObjectURL: the live preview renders inside an
  // `srcdoc` iframe, and a data URL sidesteps the origin questions a blob URL
  // raises there.
  previewCustom() {
    const file = this.customFileTarget.files?.[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = () => {
      this.customPreviewTarget.src = reader.result
      this.selectCustom(true)
    }
    reader.readAsDataURL(file)
  }

  // Ticking "remove" must also give up the selection, or the form would save
  // "custom" with nothing attached — which the model rejects.
  removeCustom(event) {
    if (!event.target.checked) return

    this.customFileTarget.value = ""
    const firstPreset = this.avatarFieldsTarget.querySelector("input[type=radio]:not([data-toggle-element-target~='customRadio'])")
    if (firstPreset) {
      firstPreset.checked = true
      firstPreset.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  // Checking the radio in JS fires no change event of its own, so dispatch one:
  // that is what repaints the launcher in the live preview.
  selectCustom(checked) {
    if (!this.hasCustomRadioTarget) return

    this.customRadioTarget.checked = checked
    this.customRadioTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
